// frontend/src/pages/teacher/AssignmentCreatePage.js (نسخه اصلاح شده)

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL, getAuthHeaders } from '../../modules/api';
import { FaPlusCircle, FaBook, FaCalendarAlt, FaClipboardList, FaChalkboardTeacher, FaArrowLeft, FaSpinner } from 'react-icons/fa';
import '../../assets/styles/global.css';

const AssignmentCreatePage = () => {
    const navigate = useNavigate();

    // --- States ---
    const [formData, setFormData] = useState({
        title: '',
        content: '', // این در مدل شما description است
        dueDate: '',
        courseId: '',
        lessonId: '', 
    });
    const [courses, setCourses] = useState([]);
    const [lessons, setLessons] = useState([]);
    const [uiState, setUiState] = useState({
        isLoading: false,
        error: null,
        success: null,
        isFetchingCourses: true,
        isFetchingLessons: false,
    });

    // --- Effects ---
    useEffect(() => {
        const fetchCourses = async () => {
            try {
                // ✅✅✅ اصلاح خطای 404: آدرس API صحیح شد ✅✅✅
                const response = await axios.get(`${API_BASE_URL}/core/teacher/courses/`, getAuthHeaders());
                setCourses(response.data);
                if (response.data.length > 0) {
                    const firstCourseId = response.data[0].id;
                    setFormData(prev => ({ ...prev, courseId: firstCourseId }));
                    // پس از تنظیم دوره اول، دروس آن را واکشی کن
                    fetchLessonsForCourse(firstCourseId); 
                }
            } catch (err) {
                setUiState(prev => ({ ...prev, error: 'خطا در دریافت لیست دوره‌ها.' }));
                console.error("Error fetching courses:", err);
            } finally {
                setUiState(prev => ({ ...prev, isFetchingCourses: false }));
            }
        };

        fetchCourses();
    }, []); // وابستگی خالی، فقط یکبار اجرا می‌شود

    // ✅ تابع جدید برای واکشی دروس بر اساس دوره
    const fetchLessonsForCourse = async (courseId) => {
        setUiState(prev => ({ ...prev, isFetchingLessons: true, error: null }));
        try {
            // این API باید در بک‌اند (views.py) در TeacherLessonListCreateAPIView تعریف شده باشد
            const response = await axios.get(`${API_BASE_URL}/core/teacher/courses/${courseId}/lessons/`, getAuthHeaders());
            setLessons(response.data);
            if (response.data.length > 0) {
                setFormData(prev => ({ ...prev, lessonId: response.data[0].id }));
            } else {
                setFormData(prev => ({ ...prev, lessonId: '' })); // اگر درسی نبود
            }
        } catch (err) {
            console.error("Error fetching lessons:", err);
            setUiState(prev => ({ ...prev, error: 'خطا در دریافت دروس این دوره.' }));
        } finally {
            setUiState(prev => ({ ...prev, isFetchingLessons: false }));
        }
    };


    // --- Handlers ---
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

        // ✅ اگر کاربر "دوره" را تغییر داد، لیست "دروس" را دوباره واکشی کن
        if (name === "courseId") {
            fetchLessonsForCourse(value);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!formData.title || !formData.content || !formData.dueDate || !formData.lessonId) {
            setUiState(prev => ({ ...prev, error: 'تکمیل تمامی فیلدها (از جمله انتخاب درس) الزامی است.' }));
            return;
        }

        setUiState(prev => ({ ...prev, isLoading: true, error: null, success: null }));

        const assignmentData = {
            title: formData.title,
            description: formData.content, // ✅ نام فیلد در سریالایزر description است
            due_date: new Date(formData.dueDate).toISOString(),
            lesson: formData.lessonId, // ✅ ID درس ارسال می‌شود
            max_score: 20 // (پیش‌فرض)
        };

        try {
            // ✅ آدرس API برای ایجاد تکلیف
            await axios.post(`${API_BASE_URL}/core/teacher/assignments/`, assignmentData, getAuthHeaders());
            setUiState(prev => ({ ...prev, success: 'تکلیف با موفقیت ایجاد شد! به زودی به داشبورد منتقل می‌شوید.' }));
            
            setTimeout(() => navigate('/teacher/assignments'), 2000); // بازگشت به لیست تکالیف

        } catch (err) {
            console.error("Submit Error:", err.response?.data || err);
            const errorMsg = err.response?.data?.lesson || err.response?.data?.detail || 'ایجاد تکلیف ناموفق بود. لطفاً مجدداً تلاش کنید.';
            setUiState(prev => ({ ...prev, error: errorMsg }));
        } finally {
            setUiState(prev => ({ ...prev, isLoading: false }));
        }
    };

    // --- Render ---
    return (
        <div className="page-container" style={{maxWidth: '800px'}}>
            <div className="form-card">
                <div className="form-header">
                    <FaPlusCircle className="header-icon" />
                    <div>
                        <h1>ایجاد تکلیف جدید</h1>
                        <p>یک تکلیف استاندارد برای دانش‌آموزان خود تعریف کنید.</p>
                    </div>
                </div>

                <form onSubmit={handleSubmit} className="form-body">
                    {/* Course Selection */}
                    <div className="form-group">
                        <label htmlFor="courseId"><FaChalkboardTeacher /> ۱. انتخاب دوره</label>
                        <select 
                            id="courseId"
                            name="courseId"
                            value={formData.courseId} 
                            onChange={handleChange}
                            disabled={uiState.isFetchingCourses || uiState.isLoading}
                        >
                            {uiState.isFetchingCourses ? (
                                <option>در حال بارگذاری دوره‌ها...</option>
                            ) : courses.length > 0 ? (
                                courses.map(course => (
                                    <option key={course.id} value={course.id}>
                                        {course.title} (پایه: {course.grade?.name || '؟'})
                                    </option>
                                ))
                            ) : (
                                <option>هیچ دوره‌ای برای شما ثبت نشده است.</option>
                            )}
                        </select>
                    </div>

                    {/* ✅ Lesson Selection (بخش جدید) */}
                    <div className="form-group">
                        <label htmlFor="lessonId"><FaBook /> ۲. انتخاب درس مرتبط</label>
                        <select 
                            id="lessonId"
                            name="lessonId"
                            value={formData.lessonId} 
                            onChange={handleChange}
                            required
                            disabled={uiState.isFetchingLessons || uiState.isLoading || lessons.length === 0}
                        >
                            {uiState.isFetchingLessons ? (
                                <option>در حال بارگذاری دروس...</option>
                            ) : lessons.length > 0 ? (
                                lessons.map(lesson => (
                                    <option key={lesson.id} value={lesson.id}>
                                        درس {lesson.order}: {lesson.title}
                                    </option>
                                ))
                            ) : (
                                <option value="">درسی در این دوره یافت نشد.</option>
                            )}
                        </select>
                    </div>

                    {/* Title */}
                    <div className="form-group">
                        <label htmlFor="title"><FaBook /> ۳. عنوان تکلیف</label>
                        <input 
                            type="text" 
                            id="title"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            placeholder="مثال: حل تمرین‌های صفحه ۵۲ کتاب"
                            disabled={uiState.isLoading}
                            required
                        />
                    </div>
                    
                    {/* Content (Description) */}
                    <div className="form-group">
                        <label htmlFor="content"><FaClipboardList /> ۴. شرح کامل تکلیف</label>
                        <textarea 
                            id="content"
                            name="content"
                            value={formData.content}
                            onChange={handleChange}
                            placeholder="جزئیات، سؤالات و منابع مورد نیاز را به طور کامل شرح دهید..."
                            rows="6"
                            disabled={uiState.isLoading}
                            required
                        ></textarea>
                    </div>

                    {/* Due Date */}
                    <div className="form-group">
                        <label htmlFor="dueDate"><FaCalendarAlt /> ۵. مهلت ارسال</label>
                        <input 
                            type="datetime-local" 
                            id="dueDate"
                            name="dueDate"
                            value={formData.dueDate}
                            onChange={handleChange}
                            disabled={uiState.isLoading}
                            required
                            style={{direction: 'ltr', textAlign: 'right'}}
                        />
                    </div>
                    
                    {/* Feedback Messages */}
                    {uiState.error && <div className="alert alert-danger">{uiState.error}</div>}
                    {uiState.success && <div className="alert alert-success">{uiState.success}</div>}

                    {/* Action Buttons */}
                    <div className="form-actions">
                        <button 
                            type="button" 
                            className="button button-secondary" 
                            onClick={() => navigate('/teacher/assignments')}
                            disabled={uiState.isLoading}
                        >
                            <FaArrowLeft /> بازگشت
                        </button>
                        <button 
                            type="submit" 
                            className="button button-primary" 
                            disabled={uiState.isLoading || courses.length === 0 || lessons.length === 0}
                        >
                            {uiState.isLoading ? <FaSpinner className="spinner" /> : <FaPlusCircle />}
                            {uiState.isLoading ? 'در حال ثبت...' : 'ثبت نهایی تکلیف'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AssignmentCreatePage;